import ajax from '@utils/ajax'

/**
 * 非油相关接口
 */

const baseUrl = '/gasstationBill/daily/bill'

/**
* @page 结算日账单(非油品)
*/

// 当前账号是否有非油权限
export const getHasUnOil = params => ajax.post('/login/gas/nonoil/check', params)

// 结算日账单列表
export const nonOilList = params => ajax.post(`${baseUrl}/non/oil/list`, params)

// 结算日账单汇总
export const nonOilSummary = params => ajax.post(`${baseUrl}/non/oil/summary`, params)

/**
 * @page 结算日账单明细(非油品)
 */

// 结算日账单明细
export const nonOilDetailList = params => ajax.post(`${baseUrl}/detail/non/oil/list`, params)

// 结算日账单汇总
export const nonOilDetailSummary = params => ajax.post(`${baseUrl}/detail/non/oil/summary`, params)
